import Splide from '@splidejs/splide';

class HeroSlider {
  constructor() {
    const root = document.querySelector<HTMLElement>('.hero-slider');
    if (!root) return;

    const duration = root.getAttribute('data-duration') ?? '';
    const transition = root.getAttribute('data-transition') ?? '';

    this.init(root, duration, transition);
  }

  public init(root: HTMLElement, duration: string, transition: string) {
    let sliderPages = root.querySelectorAll('.hero-component');
    const videos = () => Array.from(root.querySelectorAll('video'));
    const toggle = root.querySelector<HTMLButtonElement>('.splide__toggle');
    const labelPlay = toggle?.dataset.labelPlay || 'Play slideshow';
    const labelPause = toggle?.dataset.labelPause || 'Pause slideshow';

    let splide = new Splide('.hero-slider', {
      type: 'loop',
      perPage: 1,
      autoplay: true,
      pagination: sliderPages.length > 1 ? true : false,
      arrows: false,
      pauseOnFocus: false,
      pauseOnHover: false,
      resetProgress: false,
      lazyLoad: false,
      interval: parseInt(duration),
      speed: parseInt(transition),
      i18n: { play: labelPlay, pause: labelPause },
    });

    const setPaused = (paused: boolean) => {
      root.classList.toggle('is-paused', paused);
      toggle?.classList.toggle('is-active', !paused);
      toggle?.setAttribute('aria-label', paused ? labelPlay : labelPause);

      videos().forEach((video) => {
        if (paused) {
          video.pause();
        } else {
          video.play().catch(() => {});
        }
      });
    };

    splide.on('pagination:updated', (data) => {
      const buttons = data.items.map((item) => item.button);
      let activeIndex = buttons.findIndex((button) => button.classList.contains('is-active'));

      buttons.forEach((button, i) => {
        button.classList.remove('before-active', 'after-active', 'is-animated');
        button.innerHTML = '';

        if (i === activeIndex) {
          button.classList.add('is-animated');
          button.innerHTML = `<span></span>`;
        } else if (i < activeIndex) {
          button.classList.add('before-active');
        } else if (i > activeIndex) {
          button.classList.add('after-active');
        }
      });
    });

    splide.on('autoplay:pause', () => setPaused(true));
    splide.on('autoplay:play', () => setPaused(false));

    // Registered before mount so it runs ahead of Splide's own toggle handler, which
    // ignores the click when there are too few slides to autoplay.
    toggle?.addEventListener('click', () => setPaused(!root.classList.contains('is-paused')));

    splide.mount();

    // Loop clones copy the slide markup, ids included; only the originals may keep them.
    root.querySelectorAll('.splide__slide--clone video[id]').forEach((video) => video.removeAttribute('id'));

    if (toggle) {
      const videoIds = videos().map((video) => video.id).filter(Boolean);
      toggle.setAttribute('aria-controls', [splide.Components.Elements.track.id, ...videoIds].join(' '));
    }

    // Splide swaps autoplay to 'pause' under prefers-reduced-motion; keep the videos and CSS animations in step.
    if (splide.options.autoplay === 'pause') {
      videos().forEach((video) => video.removeAttribute('autoplay'));
      setPaused(true);
    }
  }
}

window.addEventListener('DOMContentLoaded', function () {
  new HeroSlider();
});
